document.addEventListener('DOMContentLoaded', function() {
  // Function to sync governorate to city
  function syncGovToCity() {
    const govField = document.querySelector('[name*="[province]"]'); // Governorate field
    const cityField = document.querySelector('[name*="[city]"]'); // City field

    if (govField && cityField) {
      // Sync on initial load
      cityField.value = govField.value;

      // Sync when governorate changes
      govField.addEventListener('change', function() {
        cityField.value = govField.value;
      });
    }
  }

  // Run for checkout and address pages
  syncGovToCity();

  // Re-run if dynamic checkout elements load later
  if (typeof Shopify === 'object') {
    Shopify.on('section:load', syncGovToCity);
  }
});